import { createStore } from 'redux'

const initialState = {
  sidebarShow: true,
  asideShow: true,
  theme: 'default',
  SMSAvailable: (localStorage.getItem("SMSAvailable") != null && localStorage.getItem("SMSAvailable").toLowerCase() == 'true'),
  SecureEmail: (localStorage.getItem("SecureEmail") != null && localStorage.getItem("SecureEmail").toLowerCase() == 'true'),
  IsQuota: (localStorage.getItem("isQuota") != null && localStorage.getItem("isQuota").toLowerCase() == 'true'),
  EmailActive: (localStorage.getItem("EmailActive") != null && localStorage.getItem("EmailActive").toLowerCase() == 'true')
}

const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case 'set':
      return { ...state, ...rest }
    default:
      return state
  }
}

const store = createStore(changeState)
export default store
